import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../images/logo.png";
import home from "../images/home.png";
import score from "../images/score.png";
import website from "../images/website.png";
import certificate from "../images/certificate.png";
import property from "../images/property.png";
import user from "../images/superhero.png";
import letter from "../images/love-letter.png";
import logout from "../images/exit.png";
import "../styles/sidebar.css";
import { MdLogout } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import api from "../pages/api";

const Sidebar = () => {
    const navigate = useNavigate();
    const [unreadCount, setUnreadCount] = useState(0);

    // دریافت اطلاعات پروفایل و تعداد پیام‌های خوانده نشده
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem("accessToken");
                if (!token) return;

                const response = await api.get("pre_student/api/v3/pre-student-profile/", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (response.data && response.data.unread_messages_count !== undefined) {
                    setUnreadCount(response.data.unread_messages_count);
                }
            } catch (error) {
                console.error("Error fetching profile data:", error);
            }
        };

        fetchProfileData();
    }, []);

    const handleLogout = async () => {
        try {
            const refreshToken = localStorage.getItem("refreshToken");

            if (!refreshToken) {
                localStorage.clear();
                navigate("/login");
                window.location.reload();
                return;
            }

            await api.post("manager/api/v1/logout", { refresh: refreshToken });

            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");

            navigate("/login");
            window.location.reload();
        } catch (error) {
            console.error("Logout failed:", error);
            localStorage.clear();
            navigate("/login");
            window.location.reload();
        }
    };

    return (
        <div className="sidebar-container">
            <div className="p-5">
                <div className="d-flex justify-content-center">
                    <div className="logo-container1">
                        <span>ythonteek</span>
                        <img className="mb-3" src={logo} alt="Logo" width={42} height={42} />
                    </div>
                </div>
                <div className="mt-4" style={{ border: "1px solid rgba(0, 0, 0, 0.25)" }}></div>
                <div className="py-5 px-3 ps-0">
                    <div style={{ position: "relative" }}>
                        <NavLink to="/" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <img src={property} width={38} alt="Home" />
                            <span className="mx-2">خونه</span>
                        </NavLink>
                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink to="/about" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <img src={user} width={34} alt="user" />
                            <span className="mx-2">درباره من</span>
                        </NavLink>
                    </div>
                    <div style={{ position: "relative" }}>
                        <NavLink to="/course" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <img src={website} width={30} alt="website" />
                            <span className="mx-2"> ویدیو های من </span>
                        </NavLink>
                    </div>
                    
                    <div style={{ position: "relative" }}>
                        <NavLink to="/message" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <div style={{ position: "relative", display: "inline-block" }}>
                                <img src={letter} width={34} alt="messages" />
                                {unreadCount > 0 && (
                                    <span style={{
                                        position: "absolute",
                                        top: "-8px",
                                        right: "-8px",
                                        backgroundColor: "red",
                                        color: "white",
                                        borderRadius: "50%",
                                        padding: "2px 6px",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        minWidth: "18px",
                                        textAlign: "center",
                                        border: "2px solid white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                    }}>
                                        {unreadCount}
                                    </span>
                                )}
                            </div>
                            <span className="mx-2"> پیام های من </span>
                        </NavLink>
                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink to="/score" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <img src={certificate} width={30} alt="certificate" />
                            <span className="mx-2"> مدارک </span>
                        </NavLink>
                    </div>

                    <div style={{ position: "relative", cursor: "pointer" }} onClick={handleLogout}>
                        <div className="sidebar-itemm my-5 d-block">
                            <img src={logout} width={34} alt="logout" />
                            <span className="mx-2">بیرون رفتن</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;